import './Skills.css';

const skillsData = {
  frontend: ['React', 'Next.js', 'Angular', 'JavaScript ES6', 'HTML5', 'CSS3'],
  backend: ['Node.js', 'Sequelize', 'MySQL', 'REST APIs'],
};

const Skills = () => {
  return (
    <section className="skills" id="habilidades">
      <div className="skills-container">
        <div className="section-number">02 — Habilidades</div>
        <h2 className="section-title">Tecnologías con las que trabajo</h2>

        <div className="skills-grid">
          <div className="skill-card skill-card-frontend">
            <div className="skill-card-label">Frontend</div>
            <div className="skill-tags">
              {skillsData.frontend.map((skill) => (
                <span key={skill} className="skill-tag skill-tag-frontend">
                  {skill}
                </span>
              ))}
            </div>
          </div>

          <div className="skill-card skill-card-backend">
            <div className="skill-card-label">Backend & DB</div>
            <div className="skill-tags">
              {skillsData.backend.map((skill) => (
                <span key={skill} className="skill-tag skill-tag-backend">
                  {skill}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
